import React, { useState } from 'react';
import pt from 'prop-types';
import { Button, Stack, Typography } from '@metarouter-private/mr-mui';

// mr-mui file picker — replaces the legacy MrInputUpload so the trigger button and
// the filename text match the modal's mr-mui styling (the legacy component renders a
// brighter button and oversized text that clash with the rest of the dialog).
export default function FileSelect({ accept, onChange }) {
  const [fileName, setFileName] = useState(null);

  const handleChange = event => {
    setFileName(event.target.files[0]?.name ?? null);
    onChange(event);
    // Reset the input so re-selecting the same file still fires onChange (the
    // browser suppresses change when the chosen path is unchanged). selectFile has
    // already captured the File synchronously by this point, so clearing is safe.
    event.target.value = '';
  };

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Button component="label" variant="contained">
        Select file
        <input type="file" accept={accept} hidden data-test-id="uploadFileInput" onChange={handleChange} />
      </Button>
      <Typography variant="body2" color={fileName ? 'text.primary' : 'text.secondary'} noWrap title={fileName ?? ''}>
        {fileName ?? 'No file chosen'}
      </Typography>
    </Stack>
  );
}

FileSelect.propTypes = {
  accept: pt.string,
  onChange: pt.func.isRequired,
};
